export default __webpack_public_path__ + "static/media/coin_flip_decision_1.6f658e6b.png";